export const fixFreshdeskHostStyles = (sidebarWidth: number) => {
    const header = document.querySelector<HTMLElement>('body:not(.tickets-list-page) header.application-header');
    const ticketsHeader = document.querySelector<HTMLElement>('body.tickets-list-page header.application-header');
    const ticketsSidebar = document.querySelector<HTMLElement>('div.multiple-widget-slider.page-sidebar');

    if (header) {
        header.style.width = `calc(100% - ${sidebarWidth}px)`;
        header.style.right = `${sidebarWidth}px`;
    }

    if (ticketsHeader) {
        ticketsHeader.style.width = `100%`;
        ticketsHeader.style.right = `0px`;
    }

    if (ticketsSidebar) {
        ticketsSidebar.style.right = `${sidebarWidth}px`;
    }
};
